import mainImage from './tonie_box.jpg';
import image1 from './tonie_box1.jpg';
import image2 from './tonie_box2.jpg';
import image3 from './tonie_box3.jpg';
import image4 from './tonie_box4.jpg';

const details = [
    { 
      id: 3,
      name: 'Tonie Box',
      slideTitle: 'Tonie Box',
      slideImage: mainImage,
      images: [mainImage, image1, image2, image3, image4],
      description: 'We fell in love with tonie boxes approximately 5 years ago, and our love for them has only grown. A perfect screen-free option to entertain kids of all ages. My oldest got hers around the age of 2 and now at age 7 she still loves to listen to them on car rides, or while relaxing in her room. My younger daughter has taken more of a liking recently at age 3. We currently have 2 boxes, and easily more than 50 tonies, plus 2 wall storage units, and travel cases. Some of the girls\' current favorite tonies to listen to are: Blue\'s Clues, Gabby\'s Dollhouse, Eloise, Paw Patrol Rex + Tracker just to name a few. The customer service for tonies is also great if and when you have any issues in terms of being able to troubleshoot remotely! Great gift for the holidays!',
      link: 'https://amzn.to/4hfK5tg',

    }
]

export default details[0];